(function(angular){
	'use strict';
	
	angular
		.module('formValidationModule')
		.directive('commonPassword', [
			'$parse',
			CommonPasswordFunction
		]);
	
	function CommonPasswordFunction($parse) {
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function($scope, $elem, $attrs, ngModel) {
				$scope.$watch($attrs.ngModel, function(newValue) {
					if(angular.isDefined(newValue)) {
						var currentPassword = $parse($attrs.ngModel)($scope);
						var commonPasswords = $parse($attrs.commonPassword)($scope);
						var isValid = angular.isUndefined(commonPasswords[currentPassword]);

						ngModel.$setValidity('commonPassword', isValid);
					}
				});
			}
		};
	}
})(window.angular);